module.exports = __webpack_public_path__ + "img/aw.eb2b029d.svg";